<div class="max-page-width">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-9 col-md-8 pr-0  left-side">

        <mat-horizontal-stepper [@.disabled]="true" [linear]="isLinear" #stepper (selectionChange)="stepperSelectionChange()">

          <mat-step  class="first-step" [stepControl]="firstFormGroup">
            <form [formGroup]="firstFormGroup">
              <ng-template matStepLabel><div class="first-step col-md-2"><span class="steps-number">1</span>{{ 'SearchResults' | translate }}</div></ng-template>
              <!-- <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput placeholder="Last name, First name" formControlName="firstCtrl" >
              </mat-form-field>
              <div class="booking-steps mb-2">
                <button mat-button matStepperPrevious><fa-icon class="mr-1" [icon]="faChevronCircleLeft"></fa-icon>{{ 'Back' | translate }}</button>
                <button mat-button matStepperNext>{{ 'Next' | translate }}<fa-icon class="ml-1" [icon]="faChevronCircleRight"></fa-icon></button>
              </div>  -->
            </form>
          </mat-step>

          <mat-step  [stepControl]="secondFormGroup" >

            <form >
              <ng-template matStepLabel><div class="second-step col-md-4"><span class="steps-number">2</span>{{ 'ResultOptions' | translate }}</div></ng-template>
              <div class="booking-vehicle-type" ><booking-vehicle-type [pageType]="3" [currentStepIndex]="currentStepData" (onBookNow)="openLogin()"></booking-vehicle-type></div>
              <div class="row ">
                <div class="col-lg-9 col-md-12">
                  <booking-details [bookingData]="bookingData" [submittedData]="submittedData" ></booking-details>
                </div>
                <div class="col-lg-3 ads col-md-12 pl-0 align-items-start " >


                  <div class="supplier-box">
                    <div class="d-flex mb-2">
                      <span class="text-blue l-35 mr-auto">{{ 'AgencyInformation' | translate }}</span>
                      <!-- <button class="btnLink zoom" (click)="openAgencyMap()" disableOptionCentering>
                      <mat-icon class="supplierMapIcon" svgIcon="supplierMapIcon"></mat-icon>
                    </button> -->
                    <input class="agency-box-icon zoom" (click)="openAgencyMap()" type="image" src="assets/img/googleMapIcon.svg" >
                    </div>
                    <div class="mt-1 d-flex text-left" *ngIf="vehicleReservationCaseDetailsModel!=null">
                      <div class="mr-3"><fa-icon class="fa-s" [icon]="faMapMarkerAlt"></fa-icon></div>
                      <div class="">{{vehicleReservationCaseDetailsModel.fromAgencyName}} | {{vehicleReservationCaseDetailsModel.summaryChargePickUpLocationAddress}}</div>
                    </div>
                    <div class="mt-1 d-flex text-left" *ngIf="vehicleReservationCaseDetailsModel!=null">
                      <div class="mr-3"><mat-icon>mail</mat-icon></div>
                      <div>{{vehicleReservationCaseDetailsModel.fromAgencyEmail}}</div>
                    </div>
                    <div class="mt-1 d-flex text-left" *ngIf="vehicleReservationCaseDetailsModel!=null">
                      <div class="mr-3"><mat-icon>stay_primary_portrait</mat-icon></div>
                      <div class="agency-phone">{{vehicleReservationCaseDetailsModel.fromAgencyPhone}}</div>
                    </div>
                  </div>

                  <div class="Ads-box " *ngIf="campaignsReservationCaseModel!=null">
                    <img [src]="attachmnetService.getImageLink(vehicleReservationCaseDetailsModel.campaignsReservationCaseModel.originalCampaignID,AttachmentScopesEnum.Campaign,AttachmentTypeEnum.MemberShipBanners)"
                    (click)="openCampaignLandingPage()"
                    >
                    <div class="p-2">
                      <div class="campaign-title mb-1">{{campaignsReservationCaseModel.campaignName}}</div>
                      <div *ngIf="campaignsReservationCaseModel.discount!=null"><b>{{ 'Discount' | translate}}</b>: {{(campaignsReservationCaseModel.discount) | number : '1.2-2'}}%  {{campaignsReservationCaseModel.discountScopeName}}</div>
                      <div><b>{{'ExpiryDate' | translate}}:</b> {{campaignsReservationCaseModel.endDateFormated}}</div>
                    <ng-container  *ngFor="let service of campaignsReservationCaseModel.campaignAdditionalServices">
                      <div *ngIf="service.quantity!=null">
                        - {{service.serviceName}} / {{'Quantity' | translate}}: {{service.quantity}}
                      </div>
                      <div *ngIf="service.quantity==null">
                        - {{service.serviceName}}
                      </div>
                    </ng-container>
                    <ng-container  *ngFor="let campaign of campaignsReservationCaseModel.campaignFreePolicies">
                      <div >
                  - {{campaign.policyTypeName}}

                    </div>
                  </ng-container>

                    </div>
                  </div>


                </div>
              </div>
              <div class="booking-btn mt-35 mb-2">
                <button (click)="openLogin()" class="btn btn-book-now" mat-button>{{ 'BookNowButton' | translate }}</button>

              </div>
              <div class="booking-steps">
                <button mat-button (click)="NavigateToSearchResults()" ><fa-icon class="mr-2" [icon]="faChevronCircleLeft"></fa-icon> <span class="mt-1">{{ 'Back' | translate }}</span></button>
              </div>

            </form>
          </mat-step>

          <mat-step [stepControl]="thirdFormGroup" #third_step>
            <ng-template matStepLabel><div class="third-step col-md-2"><span class="steps-number">3</span>{{ 'Drivers' | translate }}</div></ng-template>
            <ng-container  *ngIf="stepper.selected == third_step">
              <form >

                <div class="booking-vehicle-type"><booking-vehicle-type></booking-vehicle-type></div>

                <ng-container >
                  <driver [driverData]="driverData" [stepper]="stepper" [saveAndConfirmMsg]="saveAndConfirmMsg"></driver>
                </ng-container>
                <div class="booking-steps">
                  <button mat-button (click)="NavigateToSearchResults()" ><fa-icon class="mr-2" [icon]="faChevronCircleLeft"></fa-icon> <span class="mt-1">{{ 'Back' | translate }}</span></button>
                </div>
              </form>
            </ng-container>

          </mat-step>

          <mat-step [stepControl]="fourthFormGroup" #fourth_step>
            <ng-template matStepLabel><div class="fourth-step col-md-2"><span class="steps-number">4</span>{{ 'Payments' | translate }}</div></ng-template>
            <ng-container  *ngIf="stepper.selected == fourth_step">
              <form >

                <div class="booking-vehicle-type"><booking-vehicle-type [currentStepIndex]="currentStepData"></booking-vehicle-type></div>
                <payment [listOfPolicies]="paymentListOfPolicies" *ngIf="vehicleReservationCaseDetailsModel!=null&&stepper.selectedIndex==3" ></payment>
                <div class="booking-steps">
                  <button mat-button (click)="NavigateToSearchResults()" ><fa-icon class="mr-2" [icon]="faChevronCircleLeft"></fa-icon> <span class="mt-1">{{ 'Back' | translate }}</span></button>
                </div>
              </form>
            </ng-container>

          </mat-step>

          <mat-step >
            <ng-template matStepLabel><div class="fifth-step col-md-2"><span class="steps-number">5</span>{{ 'Confirmation' | translate }}</div></ng-template>
            <!-- <confirmation></confirmation> -->
  <!--           <div>
              <button mat-button matStepperPrevious>{{ 'Back' | translate }}</button>
              <button mat-button (click)="stepper.reset()">Reset</button>
            </div> -->
          </mat-step>

        </mat-horizontal-stepper>

      </div>
      <div class="col-lg-3 col-md-4 pr-0  mb-4 right-side">
        <find-your-ideal-car [selectedStepperIndex]="selectedStepperIndex"></find-your-ideal-car>
        <charge-summary [bookingData]="bookingData"></charge-summary>
      </div>

    </div>
  </div>
</div>
